/**
 * Pipe time chỉ dùng riêng cho trang hội thoại
 *
 */
import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import moment from "moment";
import {momentDiffTimeStamp, timeStampUnix} from '@shared/utils';
import DurationConstructor = moment.unitOfTime.DurationConstructor;

@Pipe({
  name: 'c_time',
  standalone: false,
})
export class ConversationTimePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale_id: string) {
  }

  /*
  * https://work.1app.vn/sua-cach-hien-thi-ngay.t511477.p3?businessId=124
  * param showHour hiện tại chỉ check riêng cho màn chi tiết hội thoại
  * */
  transform(value: any, type = 1, showHour = false): string {
    if (!value) return '';

    if (value.toString().length == 13) {
      value = value.toString().slice(0, -3)
    }

    // Quy chuẩn thời gian về milliseconds
    let t = Number(value);
    if (t < 9999999999) t *= 1000;

    const m = moment(t);
    if (type == 2) {
      let timeType: string = 'giây'
      let dateLater: number = 0;
      const day = moment.duration(moment().startOf('day').diff(moment.unix(value).startOf('day'))).asDays();
      let detail = '';
      if (day < 1) {
        detail = '(' + m.format('HH:mm') + ')';

        let unit: DurationConstructor = 'second';
        dateLater = momentDiffTimeStamp(timeStampUnix(), value, unit);
        if (dateLater < 1)
          return 'vừa xong ' + detail;
        switch (true) {
          case dateLater >= 60 && dateLater < 3600 : {
            unit = 'minute';
            timeType = 'phút';
            break;
          }
          case dateLater >= 3600 && dateLater < 86400: {
            unit = 'hour';
            timeType = 'giờ';
            if (moment.unix(value).add(30, 'minutes').minute() < moment().minute()) {
              value = moment.unix(value).add(-1, 'hours').unix();
            }
            break;
          }
        }
        dateLater = momentDiffTimeStamp(timeStampUnix(), value, unit);
        if (dateLater == 24 && unit == 'hour') {
          timeType = 'ngày';
          dateLater = 1;
        }
        return dateLater + ' ' + timeType + ' trước ' + detail;
      } else {
        detail = '(' + m.format('HH:mm DD/MM/YYYY') + ')';
        switch (true) {
          case day < 30: {
            timeType = 'ngày';
            dateLater = day;
            break;
          }
          case day >= 30 && day < 365: {
            timeType = 'tháng';
            dateLater = Math.round(day / 30);
            if (dateLater == 12) {
              dateLater = 1;
              timeType = 'năm';
            }
            break;
          }
          case day >= 365: {
            dateLater = Math.floor(day / 365);
            timeType = 'năm';
            break;
          }
        }
        return dateLater + ' ' + timeType + ' trước ' + detail;
      }
    }

    // Chỉ hiển thị giờ khi thời gian hội thoại phát sinh trong ngày.
    if (moment().isSame(m, 'day')) {
      return m.format('HH:mm');
    }

    // Hiển thị đối với VN khi hội thoại phát sinh cùng năm.
    if (this.locale_id == 'vi' && moment().isSame(m, 'year')) {
      return m.format(showHour ? 'DD/MM HH:mm' : 'DD/MM');
    }

    // Sử dụng locale nếu khác năm cho tất cả trường hợp.
    return m.locale(this.locale_id).format('L');
  }
}
